























































































































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import GeneralModule from '@/store/modules/General';
import CurrencyModule from '@/store/modules/Currency';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Pagination from '@/components/Pagination.vue';
import DownlineBody from '@/components/Table/DownlineBody.vue';
import DownlineHistoryBody from '@/components/Table/DownlineHistoryBody.vue';
import ManageMixin from '@/mixins/Manage.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import UserData from '@/data/User';
import utils from '@/services/utils';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    DownlineBody,
    DownlineHistoryBody,
  },
  mixins: [ManageMixin],
})
export default class Downline extends Mixins(ManageMixin, ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  CurrencyInstance = getModule(CurrencyModule, this.$store);

  historyPage = 1;

  userId = this.AuthInstance.user._id;

  _id = '';

  username = '';

  source = this.AuthInstance.user.source;

  searchUsername = '';

  role = 'All';

  startCount = 1;

  PaginationDetail = {
    page: 1,
    amount: 0,
    limit: 100,
  };

  modalDataEditCurrency: any = {
    showCurrencySigns: false,
    username: '',
  };

  modalShowEditCurrency = false;

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      userId: this.AuthInstance.user._id,
      source: this.AuthInstance.user.source,
    },
  ];

  BreadcrumbList: any = [];

  TableHeadDownLine = UserData.TableHeadDownLine;

  TableHeadTran = UserData.TableHeadTran;

  checkRole = utils.getUserPersistent().user.userPermission.member === 'edit';

  historyData = [];

  header: any = [];

  totalCurrency: any = [];

  currentCurrency: any = [];

  showFilterCurrency = false;

  currencyRate = {};

  reportCurrency = '';

  activeCurrency = 'All';

  currencyList: string[] = [];

  get hasDownlineData(): boolean {
    if (!Array.isArray(this.userList) || this.userList.length === 0) return false;

    if (this.showFilterCurrency) return true;

    if (!Array.isArray(this.currencyList) || this.currencyList.length === 0) return false;

    return this.currencyList.some((item: any) => this.userList.some((user: any) => {
      if (user.currency) return user.currency === item;
      return user._id === item;
    }));
  }

  async created() {
    await this.fetchUsers();
    if (!['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role)) {
      const header = this.checkRole
        ? UserData.TableHeadDownLine[0].filter((v) => v.displayName !== 'account.downline.edit_pt')
        : UserData.TableHeadDownLineCheckRole[0].filter(
          (v) => v.displayName !== 'account.downline.edit_pt',
        );
      this.header = [header];
    } else {
      this.header = this.checkRole
        ? UserData.TableHeadDownLine
        : UserData.TableHeadDownLineCheckRole;
    }
    if (this.AuthInstance.user.role !== 'SUPERADMIN') {
      this.header[0] = this.header[0].filter((v) => v.displayName !== 'account.downline.editcurrencyinfo'); // Remove 'edit currency info' column
    }
  }

  setCurrency(item) {
    this.activeCurrency = item;
    this.currencyList = item === 'All' ? [...this.totalCurrency] : [item];
  }

  submit() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  handleSeperate() {
    this.showFilterCurrency = !this.showFilterCurrency;
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  async LoadSheet() {
    const {
      PaginationDetail: { page, limit },
      searchUsername,
      role,
      username,
      source,
      _id,
    } = this;

    this.GeneralInstance.toggleLoading(true);
    try {
      const criteria = searchUsername
        ? {
          username: searchUsername.trim(),
          multicurrency: this.showFilterCurrency,
        }
        : {
          pageOption: { page, limit },
          role,
          username,
          source,
          _id,
          userId: this.AuthInstance.user._id,
          multicurrency: this.showFilterCurrency,
        };

      const blob: Blob = await this.AccountInstance.DownlineDownloadSheet(criteria);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const timestamp = this.$moment().format('YYYY-MM-DD_HH-mm');
      a.download = `Downline_${timestamp}.zip`;
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } finally {
      this.GeneralInstance.toggleLoading(false);
    }
  }

  async fetchUsers() {
    const {
      PaginationDetail: { page, limit },
      searchUsername,
      // BreadcrumbDefault,
      role,
      username,
      source,
      _id,
    } = this;
    let res;
    this.GeneralInstance.toggleLoading(true);
    const Response = await this.CurrencyInstance.fetchCurrencyRate({ data: { currency: '' } });
    const allCurrency = Response.currency;
    this.currencyRate = Response.rateCurrency;
    if (searchUsername) {
      this.role = 'All';
      res = await this.AccountInstance.FetchDownLineSearch({
        username: searchUsername.trim(),
        multicurrency: this.showFilterCurrency,
      });
    } else {
      res = await this.AccountInstance.FetchDownLine({
        pageOption: {
          page,
          limit,
        },
        role,
        username,
        source,
        _id,
        userId: this.AuthInstance.user._id,
        multicurrency: this.showFilterCurrency,
      });
    }
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      const { users, pagination, breadcrumb } = this.AccountInstance.users;
      this.startCount = pagination ? pagination.startCount : 1;
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...breadcrumb];
      this.startCount = pagination ? pagination.startCount : 1;
      const resultData = users ? [...users] : [];
      let dataCurrency: any[];
      if (this.BreadcrumbList.length > 1 && !searchUsername) {
        const query = {};
        allCurrency.forEach(async (v: any) => {
          resultData.forEach(async (w: any) => {
            if (v === w.currency) {
              if (query[v]) query[v] = [...query[v], w.currency].sort();
              else query[v] = [w];
            }
            if (v !== w.currency && !query[v]) query[v] = [];
          });
        });
        dataCurrency = resultData.map((item: any) => item.currency || 'THB');
      } else {
        dataCurrency = resultData.map((item: any) => item._id || 'THB');
      }
      const newCurrency = [...new Set(dataCurrency.length ? dataCurrency : ['No Data'])];
      this.totalCurrency = newCurrency[0] !== 'No Data'
        ? newCurrency.sort((a: any, b: any) => (a > b ? 1 : -1))
        : this.currentCurrency;
      this.currencyList = [...this.totalCurrency];
      this.userList = resultData;
      this.PaginationDetail.amount = pagination ? pagination.pageAmount : 0;
    }
  }

  changePage(i) {
    this.PaginationDetail.page = i;
    this.fetchUsers();
  }

  async report(user) {
    this.reportCurrency = user.currency;
    this.historyPage = 1;
    this.currentSelectUser = user._id;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.FetchHistory({
      userId: this.currentSelectUser,
      multicurrency: this.showFilterCurrency,
    });
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      this.pageRenderHistory();
      this.modal.report = true;
    }
  }

  pageRenderHistory() {
    this.historyData = this.AccountInstance.history.slice(
      (this.historyPage - 1) * 5,
      this.historyPage * 5,
    );
  }

  handlePage(param) {
    this.historyPage += param;
    this.pageRenderHistory();
  }

  async editShowCurrency(user) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ProfileInstance.GetProfile(user._id);
    if (res.status.code) this.checkError(res.status);
    this.modalDataEditCurrency.username = user.username;
    const active = res.data.showCurrencySigns !== undefined
      ? res.data.showCurrencySigns
      : true;
    this.modalDataEditCurrency.showCurrencySigns = active;
    this.modalShowEditCurrency = true;
    this.GeneralInstance.toggleLoading(false);
  }

  async submitEditShowCurrency() {
    const params = {
      username: this.modalDataEditCurrency.username,
      isShowCurrencySigns: !this.modalDataEditCurrency.showCurrencySigns,
    };
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.UpdateShowCurrencySigns(params);
    if (res.code) this.checkError(res.code);
    this.modalDataEditCurrency.showCurrencySigns = res.showCurrencySigns;
    this.GeneralInstance.toggleLoading(false);
  }

  editPT(user) {
    this.currentSelectUser = user._id;
    this.modal.pt = true;
  }

  async submitEditPT() {
    const params = {
      userId: this.currentSelectUser,
      general: this.modalData.pt.general / 100,
      pg: this.modalData.pt.general / 100,
      ds: this.modalData.pt.general / 100,
    };
    const res = await this.AccountInstance.UpdateCommission(params);
    this.alert(res);
  }

  alert(res) {
    const { code } = res;
    if (code === 0) {
      this.modalData = {
        profile: UserData.initialUserInfo(),
        lock: UserData.initialLock(),
        password: UserData.initialPassword(),
        pt: UserData.initialPT(),
        refill: UserData.initialRefill(),
        deduct: UserData.initialDeduct(),
      };
    }
    this.modal = UserData.initialModal();
    this.checkError(res);
    this.fetchUsers();
  }

  async handleSub(user) {
    this.prepareFetch(user);
  }

  async handleBreadcrumb(user) {
    this.prepareFetch(user);
  }

  handleLevel() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  prepareFetch(user) {
    this.userId = user._id;
    this._id = user._id;
    this.username = user.username;
    this.source = user.source;
    this.PaginationDetail.page = 1;
    this.searchUsername = '';
    this.currentCurrency = [user.currency];
    this.fetchUsers();
  }
}
